module.exports = __webpack_public_path__ + "static/media/Silvana Macri.09b4ef8b.jpg";